import { render, staticRenderFns } from "./CopyFeature.vue?vue&type=template&id=f6268650"
import script from "./CopyFeature.vue?vue&type=script&lang=js"
export * from "./CopyFeature.vue?vue&type=script&lang=js"
import style0 from "./CopyFeature.vue?vue&type=style&index=0&id=f6268650&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports